// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__11L5b","prefix":"styles_prefix__1gvVy","prefixDisable":"styles_prefixDisable__3qwS4","prefixInvalid":"styles_prefixInvalid__2zl63"};